<template>
  <div>

    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <i class="el-icon-picture"></i><b>定标附件上传</b>
      </div>
      <el-table :data="dt4" border style="width: 100%;" :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" highlight-current-row>
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column label="文件名称" prop="ctype_file" width="200"></el-table-column>
        <el-table-column label="上传人" prop="cvenname_file" width="200"></el-table-column>
        <el-table-column label="上传日期" prop=" curl_file"></el-table-column>
        <el-table-column label="预览" width="80">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="GetHTFileUrl(scope.row)">预览</el-button>
            <el-button size="mini" type="primary" plain @click="GetHTFileUrl(scope.row)">上传附件</el-button>
            <el-button size="mini" type="primary" plain @click="GetHTFileUrl(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <i class="el-icon-s-data"></i><b>付款条款</b>
      </div>
      <el-table :data="dt5" border style="width: 100%;" :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" highlight-current-row>
        <el-table-column label="付款阶段" prop="cvenname_grive"></el-table-column>
        <el-table-column label="付款比率%" prop="cmwskz"></el-table-column>
        <el-table-column label="付款金额" prop="ctaxname"></el-table-column>
        <el-table-column label="付款说明" prop="itaxrate" width="120"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    dt4: { Type: Array },
    dt5: { Type: Array },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    GetHTFileUrl(row) {
      if (row.curl_file != "" && row.curl_file != undefined) {
        window.open(this.global.BASE_URL + row.curl_file);
      } else {
        this.$message.error("暂无文件！！");
      }
    },
  },
};
</script>
<style scoped>
.inputwidth {
  width: 30%;
}
.inputwidth .el-input__inner {
  border: 0;
}
</style>

